import { render, staticRenderFns } from "./wxscustomer.vue?vue&type=template&id=60b4de00&"
import script from "./wxscustomer.vue?vue&type=script&lang=js&"
export * from "./wxscustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports